import { useMenuState } from "react-admin-base-bootstrap";
import React, { createContext, useContext } from "react";
const MenuStateContext = createContext(null);
export function useGlobalMenuState() {
    return useContext(MenuStateContext);
}
export function ToggleButton() {
    const [menuOpen, toggleMenu] = useGlobalMenuState();
    return React.createElement("button", { type: "button", className: "btn btn-sm px-3 font-size-24 header-item waves-effect", id: "vertical-menu-btn", onClick: toggleMenu },
        React.createElement("i", { className: "ri-menu-2-line align-middle" }));
}
export default function GlobalMenuStateProvider({ children }) {
    const state = useMenuState();
    return React.createElement(MenuStateContext.Provider, { value: state }, children);
}
